import { TableFieldModel } from '@/model/TableList'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'no',
    fieldName: '行政编码'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '行政名称'
  }
]
